module.exports = __webpack_public_path__ + "static/media/R-360HD_EC_CrossSection.3ca75507.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-360HD_EC_CrossSection.png
// module id = 916
// module chunks = 0